// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { homePageLayoutStyles } from "@synd/App/Widgets/Layout/HomePageLayout";
import { DivWrapper } from "@synd/XDL/constants";
import { xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

homePageLayoutStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 24px;
    `,
};

homePageLayoutStyles.container = {
    css: css`
        column-gap: 22px;
        row-gap: 24px;
        display: grid;
        grid-template-columns: 317px minmax(0, 1fr);
        ${xScreen("lte", "md")} {
            display: flex;
            flex-direction: column;
        }
    `,
};

homePageLayoutStyles.leftSection = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 24px;
        column-gap: 20px;
        grid-column: 1;
        & > ${DivWrapper}:empty {
            display: none;
        }
        ${xScreen("lte", "md")} {
            max-width: 100%;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
        }
        ${xScreen("lt", "sm")} {
            grid-template-columns: 1fr;
        }
    `,
};

homePageLayoutStyles.verticalWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 24px;
    `,
};

homePageLayoutStyles.rightSection = {
    css: css`
        display: flex;
        row-gap: 24px;
        flex-direction: column;
        grid-column: 2;
        & > ${DivWrapper}:empty {
            display: none;
        }
    `,
};
